import {appTasks, postData} from "../../utils/Utils.js";

const PostList = (domEl) => {

	if(!domEl) {
		return;
	}

	// The "views"
	const timeline = domEl.querySelector('.timeline');
	let lastPost = timeline.querySelector('.post-timeline-item:last-child');

	// "State management"
	let isLocked = false;
	let resetTimeline = false;
	let allFetched = false;
	let timeoutPreloader = null;

	// Static FormData to send
	let orderBy = domEl.getAttribute('data-orderby');
	const headingLevel = domEl.getAttribute('data-heading-level');
	const categories = domEl.getAttribute('data-categories');
	const postsPerPage = parseInt(domEl.getAttribute('data-posts_per_page'));
	const enableLoadMore = domEl.getAttribute('data-enable-load-more');
	let offset = parseInt(domEl.getAttribute('data-offset'));

	// Aria labels
	const ariaTimeline = domEl.getAttribute('data-aria-timeline');
	const ariaTimelineLoading = domEl.getAttribute('data-aria-timeline-loading');

	// Function to check if the user has scrolled near the bottom of the last offer post
	const isNearBottom = (offset = -100) => {
		if(!lastPost) {
			return false;
		}

		const lastOfferPosition = lastPost.getBoundingClientRect().bottom;
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;
		return lastOfferPosition - windowHeight <= offset;
	}

	const observeNewElements = () => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach(entry => {
					if(entry.isIntersecting) {
						entry.target.classList.add('in-view');
						observer.unobserve(entry.target);
					}
				});
			},
			{
				rootMargin: '0px 0px -50px 0px',
				threshold: 0.1
			}
		);
		timeline.querySelectorAll('.io-animation:not(.in-view)').forEach(el => observer.observe(el));
	};


	const render = () => {

		if(isLocked) {
			return;
		}
		isLocked = true;

		if(resetTimeline) {
			allFetched = false;
			offset = 0;
		}

		// Build FormData
		const formData = new FormData();
		const task = appTasks.loadPosts; // From theme-setup.php
		const searchParams = new URLSearchParams(window.location.search);

		formData.append('action', task.action);
		formData.append('nonce', task.nonce);
		formData.append('orderby', orderBy);
		formData.append('posts_per_page', postsPerPage);
		formData.append('offset', offset);
		formData.append('heading-level', headingLevel);
		formData.append('categories', categories);

		// Preloader begin
		clearTimeout(timeoutPreloader);
		timeoutPreloader = setTimeout(showPreloader, 1);

		postData(task.url, formData)
			.then(response => {
				// Preloader end
				clearTimeout(timeoutPreloader);
				showPreloader(false);

				if(!response.success) {
					isLocked = false;
				}
				else {

					if(resetTimeline) {
						// Store announcement div before clearing
						const announcement = domEl.querySelector('.announcement');
						const savedAnnouncement = announcement.cloneNode(true);
						timeline.innerHTML = '';
						// Re-add announcement
						timeline.insertBefore(savedAnnouncement, timeline.firstChild);
						// Return focus to filter when resetting
						//document.querySelector('#year-selection').focus();
					}

					//const lastPostOffset = timeline.getBoundingClientRect().bottom;
					const scrollPosition = window.scrollY || document.documentElement.scrollTop;

					// We need a reference to the last post, so we can focus on the next one
					const lastPostBeforeAppend = timeline.lastElementChild;

					timeline.insertAdjacentHTML('beforeend', response.data.list);

					// Add an announcement for screen readers
					const announcement = domEl.querySelector('.announcement');
					announcement.textContent = `Loaded ${response.data.foundPostsBatch} new posts`;

					offset += postsPerPage;

					observeNewElements();

					window.scrollTo(0, scrollPosition);

					// Manage focus
					let postToFocus;

					// Scenario 1: We've reset the timeline, so focus on its first child
					if(resetTimeline) {
						//postToFocus = timeline.firstElementChild;
						postToFocus = announcement.nextElementSibling;
					}
					else if(lastPostBeforeAppend) { // Scenario 2: We've added to the timeline, so focus on the post after the previous last post
						postToFocus = lastPostBeforeAppend.nextElementSibling;
					}

					// Check if postToFocus is valid and focus on its permalink
					if(postToFocus) {
						const permalinkInsidePostToFocus = postToFocus.querySelector('.permalink-image');

						// If the permalink isn't naturally focusable, make it so by setting its tabindex
						if(permalinkInsidePostToFocus && !permalinkInsidePostToFocus.hasAttribute('tabindex')) {
							permalinkInsidePostToFocus.setAttribute('tabindex', '0');
						}

						// Store current scroll position
						const scrollPosition = window.scrollY;

						// Set focus
						permalinkInsidePostToFocus && permalinkInsidePostToFocus.focus();

						// Restore scroll position
						window.scrollTo(0, scrollPosition);
					}
				}

				// Update reference to the last offer post
				lastPost = timeline.querySelector('.post-timeline-item:last-child');

				// Update the history so we can go back and forth
				if(parseInt(response.data.foundPostsBatch) > 0) {
					const urlParams = new URLSearchParams(window.location.search);
					const side = resetTimeline
						? 0
						: (urlParams.get('side') ? urlParams.get('side') : 1);
					urlParams.set('side', String(side ? parseInt(side) + 1 : 1));

					const newUrl = `${window.location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
					window.history.replaceState({ path: newUrl }, '', newUrl);
				}

				// Unlock so we're ready for the next batch
				resetTimeline = false;
				allFetched = parseInt(response.data.foundPosts) <= offset;
				isLocked = false;
			})
			.catch(function(err) {
				//console.log(err);
				isLocked = false;
				clearTimeout(timeoutPreloader);
				showPreloader(false);
			});
	};

	const showPreloader = (show = true) => {
		timeline.setAttribute('aria-busy', show ? 'true' : 'false');
		timeline.setAttribute('aria-label', show ? ariaTimelineLoading : ariaTimeline);
	}

	//
	// Initialize

	// Function to get current query parameters
	function getCurrentQueryParams() {
		return new URLSearchParams(window.location.search);
	}

	// Store the initial query parameters
	let previousQueryParams = getCurrentQueryParams();

	// Modified event listeners
	window.addEventListener('popstate', () => {
		const currentParams = getCurrentQueryParams();
		//resetTimeline = shouldResetTimeline(previousQueryParams, currentParams);
		resetTimeline = true;
		render();
		previousQueryParams = currentParams;
	});

	window.addEventListener('replaceState', () => {
		const currentParams = getCurrentQueryParams();
		//resetTimeline = shouldResetTimeline(previousQueryParams, currentParams);
		resetTimeline = true;
		render();
		previousQueryParams = currentParams;
	});

	const initialPostCount = parseInt(domEl.getAttribute('data-initial-post-count'));
	const initialFoundPosts = parseInt(domEl.getAttribute('data-initial-found-posts'));
	allFetched = initialPostCount >= initialFoundPosts;

	// Scroll event listener
	if(enableLoadMore) {
		window.addEventListener('scroll', () => {
			if(!isLocked && !allFetched && isNearBottom()) {
				render();
			}
		});
	}
};

export default PostList;